import React, { useContext } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { OccurrenceFrequencyPropsShape } from "../../interfaces/componentTypes";
import { GoalFormDropdown } from "./GoalFormDropdown";

export const OccurrenceFrequency: React.FunctionComponent<OccurrenceFrequencyPropsShape> = ({
  handleTimeframe,
  context,
}) => {
  const { DBObject, t } = useContext(TMDataContext);
  const { goalState } = useContext(context);
  let activeId = "goal-frequency-selector";

  return (
    <div className="goal-frequency-option">
      <label className="goal-input-area-title" htmlFor={activeId}>
        {t("views.goals.headings.occurrence")}
      </label>
      <GoalFormDropdown
        selection={DBObject}
        dropdownId={activeId}
        child={"OccurrenceFrequencyLevel"}
        handleSelect={handleTimeframe}
        selectedItem={goalState["occurrenceFrequency"]}
      />
    </div>
  );
};
